import * as t from "io-ts"

export const propertyAddressSchema = t.exact(
  t.partial({
    buildingName: t.union([t.null, t.string]),
    buildingNumber: t.union([t.null, t.string]),
    street: t.union([t.null, t.string]),
    subBuilding: t.union([t.null, t.string]),
    postcode: t.union([t.null, t.string]),
  })
)

export type PropertyAddress = t.TypeOf<typeof propertyAddressSchema>

type AddressFormat = "one-line" | "new-lines" | undefined

export const formatAddress = (
  propertyAddress?: PropertyAddress | null,
  formatStyle: AddressFormat = "one-line"
): string | null => {
  if (!propertyAddress) {
    return null
  }

  const { buildingName, buildingNumber, street, postcode, subBuilding } =
    propertyAddress
  if (!buildingName && !buildingNumber) {
    return null
  }

  const truthy = (s: string | null | undefined): boolean => !!s

  return [
    [subBuilding, buildingName].filter(truthy).join(" "),
    [buildingNumber, street].filter(truthy).join(" "),
    truthy(postcode) ? postcode : "",
  ]
    .filter(truthy)
    .join(formatStyle === "new-lines" ? "\n" : ", ")
}
